/**
 * Shared JSON-LD structured data for public pages.
 * Organization = Should I Studios LLC (brand: GreyRock AI).
 * No founder or personal names — keep it that way.
 */

export const ORGANIZATION_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Should I Studios LLC",
  url: "https://shouldistudios.com",
  brand: {
    "@type": "Brand",
    name: "GreyRock AI",
  },
  logo: "https://greyrockai.app/logo-512.png",
  sameAs: [
    "https://shouldistudios.com",
    "https://www.tiktok.com/@greyrockai",
    "https://www.instagram.com/greyrockai/",
    "https://www.youtube.com/@greyrockai",
  ],
};

export const SOFTWARE_APPLICATION_LD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": "https://greyrockai.app/#software",
  name: "GreyRock AI",
  url: "https://greyrockai.app",
  applicationCategory: "LifestyleApplication",
  operatingSystem: "Web",
  description:
    "AI-powered communication analysis tool. Paste any message to see manipulation, gaslighting, and coercive-control patterns named in seconds.",
  disambiguatingDescription:
    "GreyRock AI is a web-based message-analysis tool by Should I Studios LLC that names manipulation patterns such as gaslighting and DARVO in text conversations. It is not affiliated with the GreyRock co-parenting documentation app.",
  publisher: {
    "@type": "Organization",
    name: "Should I Studios LLC",
    url: "https://shouldistudios.com",
  },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
  },
};
